import Vue from 'vue'
import App from './App.vue'
import router from '@/router'

import { store } from './vuex'
import './ml'

Vue.config.productionTip = false
//Vue.prototype.$url = 'https://vrglass.com/oracle/loja/';
//Vue.prototype.$url = 'https://local.oracle2021.com.br/';
//Vue.prototype.$url = 'https://farma.vrglass.com/';
//Vue.prototype.$url = 'https://eletro.vrglass.com/';
Vue.prototype.$url = 'https://iplace.vrglass.com/';
//Vue.prototype.$url = 'https://agro.vrglass.com/';
Vue.prototype.$url_oracle = 'https://ademosrv0033c1dev-store.demoservices011.commerce.oraclepdemos.com';
Vue.prototype.$url_zapt = 'https://us-central1-zapt-bigdata.cloudfunctions.net/userLocation';
Vue.prototype.$logged = false;


new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')